enum VanillaPagesType {
  discussions = "discussions",
  discussions_tagged = "discussions_tagged",
  discussions_bookmarked = "discussions_bookmarked",
  discussions_mine = "discussions_mine",
  discussion = "discussion",
  discussion_edit = "discussion_edit",
  discussion_create = "discussion_create",
  event = "event",
  event_edit = "event_edit",
  event_create = "event_create",
  homepage = "homepage",
  custompage = "custompage",
  categories = "categories",
}

export { VanillaPagesType };
